export default "__VITE_ASSET__f9f889f1__"